import React from "react";
import "./About.css";
import logo from "../../Assets/Logo.jpeg";
import { Helmet } from "react-helmet-async";

const About = () => {
  const PHONE_NUMBER = "+919755357721"; // ✅ UPDATED NUMBER

  const handleCall = () => {
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  return (
    <>
      <Helmet>
        <title>
          About Shree Ram Car Rental | Self Drive & Taxi Service in Indore
        </title>

        <meta
          name="description"
          content="About Shree Ram Car Rental - trusted self drive and taxi service in Indore. 10+ years experience, 15K+ happy customers. Book now!"
        />

        {/* ✅ UPDATED DOMAIN */}
        <link rel="canonical" href="https://www.shreeramcarrental.com/about" />

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Shree Ram Car Rental",
            "url": "https://www.shreeramcarrental.com/about",
            "description": "Trusted car rental service in Indore with 10+ years experience."
          }
          `}
        </script>
      </Helmet>

      <section className="about-page-dark" id="about">
        <div className="bg-glow-about"></div>

        <div className="about-container">
          <div className="about-grid">
            
            <div className="about-visual">
              <div className="glass-image-card">
                <img
                  src={logo}
                  alt="Shree Ram Car Rental logo - self drive car rental in Indore"
                  className="about-logo-main"
                />

                <div className="experience-float">
                  <span className="exp-number">10+</span>
                  <span className="exp-text">Years of Excellence</span>
                </div>
              </div>
            </div>

            <div className="about-info">
              <span className="section-badge">SINCE 2014</span>

              <h1 className="about-title">
                Indore's Premier <span>Car Rental</span> Partner
              </h1>

              <h2 className="about-subtitle">
                Trusted Self Drive & Taxi Services in Indore
              </h2>

              <p className="about-lead">
                Welcome to <strong>Shree Ram Car Rental</strong>. We provide
                reliable <strong>self drive cars in Indore</strong> along with
                professional taxi services. From local city rides to long-distance
                outstation trips, our fleet is available 24/7 for your comfort.
              </p>

              <p className="about-links">
                Explore our{" "}
                <a href="/self-drive-cars">self drive cars</a> or book{" "}
                <a href="/temple-tours">temple tours in Indore</a> easily.
              </p>

              <div className="trust-pills">
                <div className="pill">⭐ 4.9/5 Rating</div>
                <div className="pill">📍 Based in Indore</div>
                <div className="pill">🛡️ Fully Insured</div>
              </div>

              <div className="about-features-list">
                <div className="feature-card">
                  <div className="f-icon">🚕</div>
                  <div className="f-text">
                    <h3>Professional Drivers</h3>
                    <p>Verified, punctual, and experienced drivers.</p>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="f-icon">💎</div>
                  <div className="f-text">
                    <h3>Luxury Fleet</h3>
                    <p>From budget cars to premium SUVs & luxury vehicles.</p>
                  </div>
                </div>
              </div>

              <div className="about-stats-row">
                <div className="stat-item">
                  <strong>15K+</strong>
                  <span>Happy Clients</span>
                </div>
                <div className="stat-item">
                  <strong>50+</strong>
                  <span>Vehicles</span>
                </div>
                <div className="stat-item">
                  <strong>24/7</strong>
                  <span>Support</span>
                </div>
              </div>

              <button className="about-cta-neon" onClick={handleCall}>
                Talk to Our Travel Expert →
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;